<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-10-24 17:45:40
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-27 22:12:56
 * @Description: file content
 -->
<template>
  <div class="scroll-view_hor_salesperson">
    <div class="person-wrap" ref="personWrap">
      <ul ref="personTab">
        <li class="item" v-for="(item,index) in list" :key="index">
          <div class="div1">{{item.counselorname || item.counselornickname}}</div>
          <div class="div2">
            <img :src="item.headimgurl" alt @click="clickHead(item)" />
          </div>
          <div class="div3">
            <img
              src="https://assets.rurushishi.com//yq-rs-make/components/scroll-view_hor_salesperson/weixin.png?x-oss-process=image/resize,p_100"
              alt
              @click="clickWx(item)"
            />
            <img
              src="https://assets.rurushishi.com//yq-rs-make/components/scroll-view_hor_salesperson/dianhua.png?x-oss-process=image/resize,p_100"
              alt
              @click="clickPhone(item)"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import BScroll from "better-scroll";
import util from "@/utils/utils";

import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {
    list: Array
  },
  data() {
    return {
      scroll: null,
      isShowBigImg: false,
      current: "",
      imgList: []
    };
  },
  watch: {},
  computed: {
    ...mapState(["userInfo", "pageInfo", "isInMiniProgram"])
  },
  methods: {
    // lj29
    clickHead(item) {
      let url = `${location.protocol}//${location.host}/h5/vcard2?saleropenid=${item.saleropenid}`;
      if (!this.isInMiniProgram || util.checkIsHaveOldMp()) {
        // 非小程序环境下加上back按钮
        url = util.addUrlParamFromObj(url, {
          backhome: "back"
        });
      }
      util.openYqRsMakeLink(url);
    },
    clickWx(item) {
      // 与销售员聊天
      util.openShqcWebChat(
        item.saleropenid,
        item.counselorname || item.counselornickname
      );
    },
    clickPhone(item) {
      util.makePhoneCall(item.mobile);
    },
    personScroll() {
      if (this.list) {
        let width = this.list.length * 140;
        this.$refs.personTab.style.width = width + "px";
        // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.personWrap, {
              startX: 0,
              click: true,
              scrollX: true,
              // 忽略竖直方向的滚动
              scrollY: false,
              eventPassthrough: "vertical"
            });
          } else {
            this.scroll.refresh();
          }
        });
      }
    }
  },
  created() {
    this.list.forEach(e => {
      this.imgList.push(e.main_img);
    });
    this.$nextTick(() => {
      this.personScroll();
    });
  },
  mounted() {}
};
</script>
<style lang="css">
.zhezhao img {
  width: 100%;
}
</style>
<style lang="css" scoped>
.person-wrap {
  overflow: hidden;
}
.item {
  width: 120px;
  height: 3rem;
  background: #fff;
  margin: 15px 10px;
  display: inline-block;
  border-radius: 0.125rem;
  /* box-shadow: 0 0 0.25rem #cbcbcb; */
  /* background-color: aquamarine; */
  border-radius: 0.125rem;
  box-shadow: 0 0 0.25rem #cbcbcb;
}
.item .div1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  height: 0.7rem;
  line-height: 0.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item .div2 {
  text-align: center;
}
.item .div2 > img {
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
}
.item .div3 {
  height: 1rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 90%;
  margin: 0 auto;
}
.item .div3 > img {
  width: 0.7rem;
  height: 0.7rem;
}
</style>